module.exports = __webpack_public_path__ + "static/media/fruits-cut1000.226cadff.jpeg";